import {
  iamAccountEntityRaw,
  IAMAccountEntityRaw
} from "@youm-front/iam-account/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class IAMAccountsListResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountsListResponseDTO.validationSchema()
  );

  constructor(readonly data: IAMAccountsListResponseDTORaw) {
    JsonSchemaValidator.validate(IAMAccountsListResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["accounts"],
      properties: {
        accounts: {
          type: "array",
          minItems: 0,
          maxItems: Number.MAX_SAFE_INTEGER,
          items: iamAccountEntityRaw
        }
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountsListResponseDTORaw {
  accounts: IAMAccountEntityRaw[];
}
